export interface ProjectItem {
  id: string;
  title: string;
  category: string;
  location: string;
  year: string;
  image: string;
  client?: string;
  area?: string;
  duration?: string;
  description: string;
  highlights: string[];
  galleryImages: { src: string; caption: string }[];
  relatedService: string;
  relatedServiceSlug: string;
}

export const projectsData: ProjectItem[] = [
  // ===== 軽鉄下地LGS工事 =====
  {
    id: 'lgs-001',
    title: '軽鉄下地LGS工事 — 大型オフィスビル',
    category: '軽鉄下地LGS工事',
    location: '東京都千代田区',
    year: '2024',
    client: '大手デベロッパー',
    area: '約2,500㎡',
    duration: '20日間',
    image: 'https://public.readdy.ai/ai/img_res/cd912fef058389844ad6cb2575e4e583.jpg',
    description: '東京都千代田区の大型オフィスビル新築工事における軽鉄下地LGS工事です。天井・壁の全面にわたるLGS下地組みを施工しました。大規模施工でも精度の高い墨出し・レベル調整を徹底し、後工程のボード工事・クロス工事がスムーズに進む高品質な下地を提供しました。',
    highlights: [
      '2,500㎡の大規模LGS下地工事を工期内に完工',
      '精度の高い墨出し・レベル調整を徹底',
      'ボード工事・クロス工事との一貫施工で工期短縮',
      '耐火性能基準をクリアした施工仕様',
      '安全管理を徹底した施工体制',
    ],
    galleryImages: [
      {
        src: 'https://static.readdy.ai/image/335e3e62ea46a4ee8fffcd870552cca1/bce8e9cd968b96d5a72e5f169b7273ee.jpeg',
        caption: '大規模施設 — LGS下地・足場組み施工現場',
      },
      {
        src: 'https://static.readdy.ai/image/335e3e62ea46a4ee8fffcd870552cca1/b554f8c2d36b87076fbc99a30a3ec131.jpeg',
        caption: '大規模施設 — LGS曲面天井・R仕様施工現場',
      },
      {
        src: 'https://static.readdy.ai/image/335e3e62ea46a4ee8fffcd870552cca1/1a4c41166ecd30be26b10ac3a7566f08.jpeg',
        caption: '大規模施設 — LGS壁下地・大空間施工現場',
      },
      {
        src: 'https://static.readdy.ai/image/335e3e62ea46a4ee8fffcd870552cca1/6fe89053bc1507ae336b857da9f1d659.jpeg',
        caption: '大規模施設 — LGS壁下地・高所作業施工現場',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=large%20office%20building%20LGS%20ceiling%20framing%20installation%20completed%20metal%20stud%20grid%20ceiling%20structure%20modern%20commercial%20building%20interior%20construction%20professional%20finish%20bright%20workspace&width=800&height=600&seq=lgs-001-g1&orientation=landscape',
        caption: 'LGS天井下地 — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=LGS%20metal%20stud%20wall%20framing%20installation%20large%20office%20building%20interior%20construction%20workers%20installing%20lightweight%20steel%20wall%20partition%20system%20professional%20construction%20team%20safety%20equipment&width=800&height=600&seq=lgs-001-g2&orientation=landscape',
        caption: 'LGS壁下地 — 施工中',
      },
    ],
    relatedService: '軽鉄下地LGS工事',
    relatedServiceSlug: 'lgs',
  },
  {
    id: 'lgs-002',
    title: '軽鉄下地LGS工事 — 耐震天井施工',
    category: '軽鉄下地LGS工事',
    location: '千葉県市川市',
    year: '2024',
    client: '公共施設管理者',
    area: '約800㎡',
    duration: '12日間',
    image: 'https://readdy.ai/api/search-image?query=completed%20seismic%20resistant%20ceiling%20system%20installed%20in%20public%20facility%20interior%20earthquake%20proof%20suspended%20ceiling%20with%20diagonal%20steel%20brace%20wires%20visible%20clean%20bright%20institutional%20building%20interior%20Japan%20no%20people%20empty%20room%20professional%20finish&width=800&height=600&seq=lgs-scene-002&orientation=landscape',
    description: '千葉県市川市の公共施設における耐震天井工法施工工事です。大規模地震時の天井落下リスクを低減するため、各メーカーの認定耐震天井工法を採用しました。ブレース・特殊金具を用いた補強施工により、高い耐震性能を実現しました。',
    highlights: [
      'メーカー認定耐震天井工法の採用',
      'ブレース・特殊金具による確実な補強施工',
      '公共施設の安全基準をクリアした施工仕様',
      '施工後の耐震性能検査・確認書類の提出',
      '既存天井の撤去から新規耐震天井施工まで一貫対応',
    ],
    galleryImages: [
      {
        src: 'https://readdy.ai/api/search-image?query=seismic%20resistant%20ceiling%20completed%20installation%20public%20facility%20interior%20earthquake%20proof%20ceiling%20system%20modern%20building%20interior%20professional%20finish%20clean%20bright%20space%20high%20quality%20construction&width=800&height=600&seq=lgs-002-g1&orientation=landscape',
        caption: '耐震天井 — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=seismic%20ceiling%20brace%20installation%20earthquake%20resistant%20ceiling%20construction%20workers%20installing%20steel%20brace%20connection%20public%20building%20interior%20construction%20professional%20team%20safety%20equipment&width=800&height=600&seq=lgs-002-g2&orientation=landscape',
        caption: 'ブレース取り付け施工',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=seismic%20ceiling%20connection%20detail%20close%20up%20special%20bracket%20earthquake%20resistant%20ceiling%20system%20metal%20connection%20professional%20construction%20quality%20public%20building%20interior%20renovation%20high%20quality%20craftsmanship%20East%20Asian%20worker&width=800&height=600&seq=lgs-002-g3&orientation=landscape',
        caption: '耐震金具の詳細',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=public%20facility%20interior%20completed%20seismic%20ceiling%20renovation%20bright%20clean%20space%20modern%20interior%20professional%20finish%20high%20quality%20construction%20result%20safe%20building%20interior&width=800&height=600&seq=lgs-002-g4&orientation=landscape',
        caption: '完成後の全体像',
      },
    ],
    relatedService: '軽鉄下地LGS工事',
    relatedServiceSlug: 'lgs',
  },
  {
    id: 'lgs-003',
    title: '軽鉄下地LGS工事 — RC造マンション内装',
    category: '軽鉄下地LGS工事',
    location: '千葉県船橋市',
    year: '2023',
    client: '不動産デベロッパー',
    area: '約1,800㎡（全18戸）',
    duration: '25日間',
    image: 'https://readdy.ai/api/search-image?query=RC%20concrete%20apartment%20building%20interior%20with%20completed%20lightweight%20steel%20stud%20LGS%20wall%20and%20ceiling%20framing%20installed%20throughout%20empty%20residential%20unit%20bare%20concrete%20walls%20with%20metal%20stud%20partitions%20ready%20for%20gypsum%20board%20installation%20modern%20Japanese%20apartment%20construction%20no%20people&width=800&height=600&seq=lgs-scene-003&orientation=landscape',
    description: '千葉県船橋市のRC造新築マンション（全18戸）における軽鉄下地LGS工事です。全戸の天井・壁下地をLGSで施工しました。RC造の躯体に対して適切なアンカー処理を行い、精度の高い下地組みを実現しました。ボード工事・クロス工事との一貫施工により、工期の大幅な短縮を達成しました。',
    highlights: [
      '全18戸・1,800㎡の大規模マンション施工',
      'RC造躯体への適切なアンカー処理',
      '各戸の間取りに対応した精密な下地組み',
      'ボード工事・クロス工事との一貫施工で工期短縮',
      '品質管理を徹底した施工体制',
    ],
    galleryImages: [
      {
        src: 'https://readdy.ai/api/search-image?query=RC%20concrete%20apartment%20building%20interior%20LGS%20wall%20framing%20installation%20completed%20modern%20residential%20construction%20clean%20workspace%20professional%20finish%20ready%20for%20board%20installation&width=800&height=600&seq=lgs-003-g1&orientation=landscape',
        caption: 'LGS壁下地 — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=apartment%20interior%20LGS%20ceiling%20framing%20installation%20RC%20building%20construction%20workers%20installing%20lightweight%20steel%20ceiling%20grid%20system%20modern%20residential%20building%20interior%20construction%20professional%20team&width=800&height=600&seq=lgs-003-g2&orientation=landscape',
        caption: 'LGS天井下地 — 施工中',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=RC%20concrete%20wall%20anchor%20installation%20detail%20close%20up%20metal%20stud%20connection%20to%20concrete%20wall%20professional%20construction%20quality%20apartment%20building%20interior%20renovation%20high%20quality%20craftsmanship%20East%20Asian%20worker&width=800&height=600&seq=lgs-003-g3&orientation=landscape',
        caption: 'アンカー処理の詳細',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=apartment%20interior%20completed%20after%20LGS%20framing%20and%20board%20installation%20modern%20residential%20space%20clean%20bright%20interior%20professional%20finish%20high%20quality%20construction%20result%20ready%20for%20wallpaper%20East%20Asian%20worker&width=800&height=600&seq=lgs-003-g4&orientation=landscape',
        caption: 'ボード施工後の完成状態',
      },
    ],
    relatedService: '軽鉄下地LGS工事',
    relatedServiceSlug: 'lgs',
  },

  // ===== ボード工事 =====
  {
    id: 'board-001',
    title: 'ボード工事 — 大型オフィス天井',
    category: 'ボード工事',
    location: '東京都港区',
    year: '2024',
    client: '大手デベロッパー',
    area: '約1,200㎡',
    duration: '15日間',
    image: 'https://readdy.ai/api/search-image?query=completed%20large%20modern%20office%20building%20interior%20with%20smooth%20white%20gypsum%20board%20ceiling%20installed%20throughout%20vast%20open%20plan%20workspace%20bright%20LED%20lighting%20recessed%20fixtures%20clean%20professional%20commercial%20interior%20Tokyo%20Japan%20no%20people%20empty%20office%20floor&width=800&height=600&seq=board-scene-001&orientation=landscape',
    description: '東京都港区の大型オフィスビル新築工事における天井ボード工事です。LGS下地工事と連携し、石膏ボード二重張りによる高い遮音性能を実現しました。大面積施工でも精度の高い仕上がりを提供し、工期内に完工しました。',
    highlights: [
      '石膏ボード二重張りによる高遮音性能',
      'LGS下地工事との一貫施工で工期短縮',
      '1,200㎡の大面積施工を工期内に完工',
      '耐火性能基準をクリアした施工仕様',
      '精度の高いレベル調整による美しい仕上がり',
    ],
    galleryImages: [
      {
        src: 'https://readdy.ai/api/search-image?query=large%20office%20building%20ceiling%20gypsum%20board%20installation%20completed%20modern%20commercial%20interior%20clean%20white%20ceiling%20professional%20finish%20bright%20open%20plan%20office%20space%20high%20quality%20construction&width=800&height=600&seq=board-001-g1&orientation=landscape',
        caption: '天井ボード — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=gypsum%20board%20ceiling%20installation%20process%20workers%20installing%20plasterboard%20panels%20large%20commercial%20building%20interior%20construction%20professional%20team%20safety%20equipment%20bright%20workspace&width=800&height=600&seq=board-001-g2&orientation=landscape',
        caption: '施工中の様子',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=office%20interior%20ceiling%20detail%20close%20up%20gypsum%20board%20joint%20treatment%20smooth%20finish%20professional%20construction%20quality%20commercial%20building%20interior%20renovation%20high%20quality%20craftsmanship%20East%20Asian%20worker&width=800&height=600&seq=board-001-g3&orientation=landscape',
        caption: 'ジョイント処理の仕上がり',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=modern%20office%20building%20interior%20completed%20renovation%20bright%20clean%20ceiling%20walls%20professional%20finish%20commercial%20workspace%20contemporary%20design%20high%20quality%20construction%20result%20East%20Asian%20worker&width=800&height=600&seq=board-001-g4&orientation=landscape',
        caption: '完成後の全体像',
      },
    ],
    relatedService: 'ボード工事',
    relatedServiceSlug: 'board',
  },
  {
    id: 'board-002',
    title: 'ボード工事 — 岩綿ジプトーン天井',
    category: 'ボード工事',
    location: '千葉県千葉市',
    year: '2023',
    client: '商業施設運営会社',
    area: '約650㎡',
    duration: '8日間',
    image: 'https://readdy.ai/api/search-image?query=completed%20commercial%20facility%20interior%20with%20uniform%20mineral%20fiber%20acoustic%20ceiling%20tiles%20installed%20in%20suspended%20grid%20system%20clean%20modern%20retail%20or%20office%20space%20bright%20lighting%20even%20grid%20pattern%20professional%20finish%20no%20people%20empty%20space%20Japan&width=800&height=600&seq=board-scene-002&orientation=landscape',
    description: '千葉県千葉市の商業施設における岩綿ジプトーン天井施工工事です。吸音性能と意匠性を兼ね備えた岩綿ジプトーンを採用し、快適な商業空間を実現しました。既存天井の撤去から新規施工まで一貫して対応しました。',
    highlights: [
      '岩綿ジプトーンによる高い吸音性能',
      '既存天井撤去から新規施工まで一貫対応',
      '商業施設の営業スケジュールに合わせた施工計画',
      '均一なグリッドパターンによる美しい仕上がり',
      '防火性能基準をクリアした施工仕様',
    ],
    galleryImages: [
      {
        src: 'https://readdy.ai/api/search-image?query=commercial%20facility%20interior%20with%20mineral%20fiber%20acoustic%20ceiling%20tiles%20completed%20installation%20clean%20modern%20space%20suspended%20ceiling%20grid%20system%20professional%20finish%20bright%20commercial%20interior%20East%20Asian%20worker&width=800&height=600&seq=board-002-g1&orientation=landscape',
        caption: '岩綿ジプトーン天井 — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=acoustic%20ceiling%20tile%20installation%20process%20workers%20installing%20mineral%20fiber%20ceiling%20panels%20commercial%20building%20interior%20construction%20professional%20team%20suspended%20ceiling%20grid%20system%20East%20Asian%20worker&width=800&height=600&seq=board-002-g2&orientation=landscape',
        caption: '施工中の様子',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=mineral%20fiber%20ceiling%20tile%20close%20up%20detail%20texture%20acoustic%20ceiling%20panel%20commercial%20building%20interior%20high%20quality%20finish%20professional%20installation%20clean%20grid%20pattern%20East%20Asian%20worker&width=800&height=600&seq=board-002-g3&orientation=landscape',
        caption: '岩綿ジプトーンの質感',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=commercial%20space%20interior%20completed%20renovation%20with%20acoustic%20ceiling%20modern%20retail%20or%20office%20space%20bright%20clean%20interior%20professional%20finish%20high%20quality%20construction%20result%20East%20Asian%20worker&width=800&height=600&seq=board-002-g4&orientation=landscape',
        caption: '完成後の全体像',
      },
    ],
    relatedService: 'ボード工事',
    relatedServiceSlug: 'board',
  },
  {
    id: 'board-003',
    title: 'ボード工事 — 化粧板壁面施工',
    category: 'ボード工事',
    location: '大阪府大阪市',
    year: '2023',
    client: 'ホテル運営会社',
    area: '約280㎡',
    duration: '10日間',
    image: 'https://readdy.ai/api/search-image?query=elegant%20luxury%20hotel%20lobby%20interior%20with%20premium%20wood%20grain%20decorative%20wall%20panels%20installed%20floor%20to%20ceiling%20warm%20amber%20lighting%20sophisticated%20atmosphere%20high%20end%20hospitality%20design%20Osaka%20Japan%20no%20people%20empty%20lobby%20refined%20interior%20finish&width=800&height=600&seq=board-scene-003&orientation=landscape',
    description: '大阪府大阪市のホテルロビー・廊下における化粧板壁面施工工事です。木目調の高級化粧板を採用し、ホテルの格調ある雰囲気を演出しました。LGS下地工事と組み合わせた一貫施工により、高精度な仕上がりを実現しました。',
    highlights: [
      '高級木目調化粧板による上質な空間演出',
      'LGS下地工事との一貫施工',
      'ホテル営業中の施工に対応（夜間・分割施工）',
      '複雑な形状・コーナー部分の精密な加工',
      '防火性能基準をクリアした不燃化粧板採用',
    ],
    galleryImages: [
      {
        src: 'https://readdy.ai/api/search-image?query=hotel%20lobby%20interior%20with%20premium%20wood%20grain%20decorative%20wall%20panels%20elegant%20sophisticated%20commercial%20space%20warm%20lighting%20high%20quality%20interior%20finish%20luxury%20hospitality%20design%20East%20Asian%20worker&width=800&height=600&seq=board-003-g1&orientation=landscape',
        caption: 'ホテルロビー — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=hotel%20corridor%20hallway%20with%20decorative%20wood%20panel%20walls%20elegant%20interior%20design%20warm%20lighting%20premium%20wall%20covering%20installation%20sophisticated%20hospitality%20interior%20high%20quality%20finish%20East%20Asian%20worker&width=800&height=600&seq=board-003-g2&orientation=landscape',
        caption: 'ホテル廊下 — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=decorative%20wall%20panel%20installation%20process%20workers%20installing%20wood%20grain%20panels%20hotel%20interior%20construction%20professional%20team%20precise%20installation%20sophisticated%20commercial%20space%20East%20Asian%20worker&width=800&height=600&seq=board-003-g3&orientation=landscape',
        caption: '施工中の様子',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=decorative%20panel%20corner%20detail%20close%20up%20precise%20joint%20treatment%20wood%20grain%20finish%20professional%20craftsmanship%20hotel%20interior%20wall%20panel%20installation%20high%20quality%20finish%20East%20Asian%20worker&width=800&height=600&seq=board-003-g4&orientation=landscape',
        caption: 'コーナー部分の精密仕上げ',
      },
    ],
    relatedService: 'ボード工事',
    relatedServiceSlug: 'board',
  },

  // ===== 壁紙クロス工事 =====
  {
    id: 'wp-001',
    title: '壁紙クロス工事 — 住宅リビング',
    category: '壁紙クロス工事',
    location: '東京都世田谷区',
    year: '2024',
    client: '個人住宅オーナー',
    area: '約85㎡',
    duration: '3日間',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20Japanese%20residential%20living%20room%20interior%20with%20freshly%20installed%20premium%20textured%20vinyl%20wallpaper%20warm%20neutral%20beige%20tones%20elegant%20modern%20minimalist%20design%20bright%20natural%20light%20wooden%20furniture%20cozy%20atmosphere%20no%20people%20empty%20room%20Tokyo&width=800&height=600&seq=wp-scene-001&orientation=landscape',
    description: '東京都世田谷区の戸建て住宅リビング・ダイニングの壁紙全面張り替え工事です。既存クロスの撤去から下地補修、新規クロス張りまで一貫して施工しました。お客様のご要望に合わせ、温かみのある質感のビニールクロスを採用し、明るく上質な空間に仕上げました。',
    highlights: [
      '既存クロス全面撤去・下地パテ処理',
      '高品質ビニールクロス採用（消臭・防カビ機能付き）',
      '綺ぎ目・コーナー部分の丁寧な仕上げ処理',
      '居住しながらの施工に対応（3日間で完工）',
      '施工後の清掃・廃材処理まで一括対応',
    ],
    galleryImages: [
      {
        src: 'https://readdy.ai/api/search-image?query=elegant%20Japanese%20living%20room%20with%20premium%20textured%20wallpaper%20warm%20neutral%20tones%20beautiful%20interior%20design%20residential%20space%20high%20quality%20wall%20covering%20installation%20bright%20modern%20room%20sophisticated%20finish%20East%20Asian%20worker&width=800&height=600&seq=wp-001-g1&orientation=landscape',
        caption: 'リビング壁面 — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=wallpaper%20installation%20process%20craftsman%20applying%20vinyl%20wallpaper%20to%20wall%20Japanese%20residential%20interior%20renovation%20worker%20smoothing%20wallpaper%20surface%20professional%20technique%20close%20up%20detail%20East%20Asian%20worker&width=800&height=600&seq=wp-001-g2&orientation=landscape',
        caption: '施工中の様子',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=Japanese%20dining%20room%20with%20clean%20white%20wallpaper%20modern%20minimalist%20interior%20design%20bright%20open%20space%20premium%20wall%20covering%20installation%20high%20quality%20residential%20interior%20warm%20lighting%20East%20Asian%20worker&width=800&height=600&seq=wp-001-g3&orientation=landscape',
        caption: 'ダイニング壁面 — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=wallpaper%20corner%20detail%20close%20up%20professional%20finish%20seamless%20joint%20treatment%20interior%20wall%20covering%20installation%20high%20quality%20craftsmanship%20residential%20renovation%20clean%20precise%20edge%20work%20East%20Asian%20worker&width=800&height=600&seq=wp-001-g4&orientation=landscape',
        caption: 'コーナー部分の仕上がり',
      },
    ],
    relatedService: '壁紙クロス工事',
    relatedServiceSlug: 'wallpaper',
  },
  {
    id: 'wp-002',
    title: '壁紙クロス工事 — オフィスビル',
    category: '壁紙クロス工事',
    location: '東京都千代田区',
    year: '2024',
    client: '都内大手企業',
    area: '約320㎡',
    duration: '5日間',
    image: 'https://readdy.ai/api/search-image?query=modern%20corporate%20office%20interior%20with%20freshly%20installed%20clean%20white%20antibacterial%20wallpaper%20throughout%20open%20plan%20workspace%20bright%20LED%20lighting%20contemporary%20Japanese%20office%20design%20professional%20atmosphere%20no%20people%20empty%20office%20Chiyoda%20Tokyo&width=800&height=600&seq=wp-scene-002&orientation=landscape',
    description: '東京都千代田区の大型オフィスビル内装リニューアル工事の一環として、執務室・会議室・廊下の壁紙全面張り替えを施工しました。オフィス環境に適した機能性クロス（抗菌・消臭）を採用し、清潔感のある明るいワークスペースを実現しました。',
    highlights: [
      '執務室・会議室・廊下など全エリア対応',
      '抗菌・消臭機能付き機能性クロス採用',
      '夜間・週末施工によるオフィス稼働への影響最小化',
      '大面積施工でも均一な仕上がりを実現',
      '廃材の適切な分別・処理対応',
    ],
    galleryImages: [
      {
        src: 'https://readdy.ai/api/search-image?query=modern%20office%20interior%20bright%20clean%20white%20walls%20professional%20workspace%20open%20plan%20office%20after%20wallpaper%20renovation%20contemporary%20commercial%20interior%20design%20high%20quality%20finish%20bright%20lighting%20East%20Asian%20worker&width=800&height=600&seq=wp-002-g1&orientation=landscape',
        caption: '執務室 — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=office%20meeting%20room%20interior%20clean%20white%20walls%20modern%20conference%20room%20after%20renovation%20professional%20workspace%20bright%20interior%20design%20high%20quality%20wall%20covering%20installation%20contemporary%20Japanese%20office%20East%20Asian%20worker&width=800&height=600&seq=wp-002-g2&orientation=landscape',
        caption: '会議室 — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=office%20corridor%20hallway%20clean%20white%20wallpaper%20installation%20modern%20commercial%20building%20interior%20renovation%20bright%20clean%20hallway%20professional%20finish%20high%20quality%20wall%20covering%20contemporary%20office%20design%20East%20Asian%20worker&width=800&height=600&seq=wp-002-g3&orientation=landscape',
        caption: '廊下 — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=wallpaper%20installation%20large%20scale%20commercial%20office%20building%20workers%20applying%20wallpaper%20professional%20team%20renovation%20interior%20finishing%20work%20bright%20workspace%20East%20Asian%20worker&width=800&height=600&seq=wp-002-g4&orientation=landscape',
        caption: '施工中の様子',
      },
    ],
    relatedService: '壁紙クロス工事',
    relatedServiceSlug: 'wallpaper',
  },
  {
    id: 'wp-003',
    title: '壁紙クロス工事 — マンション全室',
    category: '壁紙クロス工事',
    location: '神奈川県横浜市',
    year: '2023',
    client: '不動産管理会社',
    area: '約120㎡（3LDK）',
    duration: '4日間',
    image: 'https://readdy.ai/api/search-image?query=newly%20renovated%20Japanese%20apartment%203LDK%20interior%20with%20fresh%20clean%20wallpaper%20installed%20in%20every%20room%20bright%20modern%20minimalist%20living%20space%20Yokohama%20Kanagawa%20empty%20unfurnished%20apartment%20after%20renovation%20premium%20wall%20covering%20high%20quality%20finish%20no%20people&width=800&height=600&seq=wp-scene-003&orientation=landscape',
    description: '神奈川県横浜市のマンション（3LDK）の全室壁紙張り替え工事です。リビング・寝室・子供部屋・廊下・トイレ・洗面室まで全室対応しました。各部屋の用途に合わせた素材選定を行い、統一感のある上質な空間に仕上げました。',
    highlights: [
      '全室（リビング・寝室・子供部屋・廊下・水回り）対応',
      '部屋ごとに最適な素材を選定（防カビ・消臭・撥水など）',
      '入居前リフォームのため短期集中施工',
      '既存クロスの状態に応じた下地補修を徹底',
      '施工後の品質検査・清掃まで一括対応',
    ],
    galleryImages: [
      {
        src: 'https://readdy.ai/api/search-image?query=Japanese%20apartment%20living%20room%20after%20wallpaper%20renovation%20bright%20modern%20minimalist%20interior%20design%20clean%20white%20walls%20premium%20wall%20covering%20high%20quality%20residential%20space%20warm%20lighting%20East%20Asian%20worker&width=800&height=600&seq=wp-003-g1&orientation=landscape',
        caption: 'リビング — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=Japanese%20apartment%20bedroom%20after%20wallpaper%20renovation%20modern%20minimalist%20interior%20design%20clean%20walls%20premium%20wall%20covering%20installation%20high%20quality%20residential%20space%20soft%20lighting%20East%20Asian%20worker&width=800&height=600&seq=wp-003-g2&orientation=landscape',
        caption: '寝室 — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=Japanese%20apartment%20children%20room%20after%20wallpaper%20renovation%20bright%20colorful%20interior%20design%20clean%20walls%20premium%20wall%20covering%20installation%20high%20quality%20residential%20space%20cheerful%20atmosphere%20East%20Asian%20worker&width=800&height=600&seq=wp-003-g3&orientation=landscape',
        caption: '子供部屋 — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=Japanese%20apartment%20bathroom%20toilet%20wallpaper%20renovation%20moisture%20resistant%20wall%20covering%20installation%20clean%20bright%20water%20resistant%20wallpaper%20high%20quality%20residential%20interior%20finish%20East%20Asian%20worker&width=800&height=600&seq=wp-003-g4&orientation=landscape',
        caption: 'トイレ・洗面室 — 施工後',
      },
    ],
    relatedService: '壁紙クロス工事',
    relatedServiceSlug: 'wallpaper',
  },

  // ===== 床仕上工事 =====
  {
    id: 'floor-001',
    title: '床仕上工事 — マンションフローリング',
    category: '床仕上工事',
    location: '千葉県市川市',
    year: '2024',
    client: '不動産管理会社',
    area: '約240㎡（全6戸）',
    duration: '8日間',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20Japanese%20apartment%20living%20room%20with%20newly%20installed%20light%20natural%20oak%20hardwood%20composite%20flooring%20warm%20wood%20grain%20texture%20bright%20sunlight%20streaming%20through%20windows%20modern%20minimalist%20interior%20empty%20unfurnished%20room%20Ichikawa%20Chiba%20no%20people&width=800&height=600&seq=floor-scene-001&orientation=landscape',
    description: '千葉県市川市のマンション（全6戸）における複合フローリング張り替え工事です。既存床材の撤去・下地補修から新規フローリング施工まで一貫して対応しました。各戸の間取りに合わせた丁寧な割り付けを行い、美しく耐久性の高い床仕上げを実現しました。',
    highlights: [
      '全6戸・240㎡の一括施工で工期・コスト削減',
      '既存床材撤去・下地レベル調整を徹底',
      '高品質複合フローリング採用（防音・傷防止機能付き）',
      '各戸の間取りに合わせた精密な割り付け',
      '施工後の清掃・廃材処理まで一括対応',
    ],
    galleryImages: [
      {
        src: 'https://readdy.ai/api/search-image?query=Japanese%20apartment%20living%20room%20with%20new%20light%20oak%20hardwood%20flooring%20installed%20bright%20modern%20residential%20interior%20clean%20beautiful%20floor%20finish%20warm%20natural%20wood%20tone%20high%20quality%20renovation%20result%20East%20Asian%20worker&width=800&height=600&seq=floor-001-g1&orientation=landscape',
        caption: 'リビング — フローリング施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=flooring%20installation%20process%20worker%20installing%20hardwood%20floor%20planks%20Japanese%20apartment%20renovation%20craftsman%20fitting%20wood%20floor%20boards%20professional%20technique%20close%20up%20detail%20clean%20workspace%20East%20Asian%20worker&width=800&height=600&seq=floor-001-g2&orientation=landscape',
        caption: '施工中の様子',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=apartment%20bedroom%20with%20new%20wood%20flooring%20installed%20modern%20minimalist%20Japanese%20interior%20design%20clean%20beautiful%20floor%20finish%20warm%20natural%20tone%20high%20quality%20residential%20renovation%20soft%20lighting%20East%20Asian%20worker&width=800&height=600&seq=floor-001-g3&orientation=landscape',
        caption: '寝室 — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=hardwood%20floor%20detail%20close%20up%20professional%20finish%20seamless%20joint%20treatment%20wood%20flooring%20installation%20high%20quality%20craftsmanship%20residential%20renovation%20clean%20precise%20edge%20work%20natural%20wood%20grain%20East%20Asian%20worker&width=800&height=600&seq=floor-001-g4&orientation=landscape',
        caption: 'フローリング仕上がり詳細',
      },
    ],
    relatedService: '床仕上工事',
    relatedServiceSlug: 'floor',
  },
  {
    id: 'floor-002',
    title: '床仕上工事 — 医療施設長尺シート',
    category: '床仕上工事',
    location: '千葉県船橋市',
    year: '2024',
    client: '医療法人',
    area: '約520㎡',
    duration: '6日間',
    image: 'https://readdy.ai/api/search-image?query=clean%20modern%20medical%20clinic%20corridor%20with%20newly%20installed%20smooth%20grey%20antibacterial%20vinyl%20long%20sheet%20flooring%20bright%20white%20walls%20fluorescent%20lighting%20sterile%20professional%20healthcare%20environment%20Funabashi%20Chiba%20Japan%20no%20people%20empty%20hallway&width=800&height=600&seq=floor-scene-002&orientation=landscape',
    description: '千葉県船橋市のクリニック・医療施設における長尺シート床材施工工事です。抗菌・防滑機能を持つ医療用長尺シートを採用し、衛生的で安全な床環境を実現しました。廊下・診察室・処置室など全エリアを一括施工しました。',
    highlights: [
      '抗菌・防滑機能付き医療用長尺シート採用',
      '廊下・診察室・処置室など全エリア一括施工',
      '医療施設の衛生基準に対応した施工仕様',
      '継ぎ目の溶接処理による高い防水・防汚性能',
      '施設稼働スケジュールに合わせた分割施工',
    ],
    galleryImages: [
      {
        src: 'https://readdy.ai/api/search-image?query=medical%20clinic%20corridor%20with%20new%20vinyl%20long%20sheet%20flooring%20installed%20clean%20bright%20healthcare%20interior%20professional%20finish%20antiseptic%20grey%20floor%20covering%20high%20quality%20renovation%20result%20hospital%20hallway%20East%20Asian%20worker&width=800&height=600&seq=floor-002-g1&orientation=landscape',
        caption: '廊下 — 長尺シート施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=vinyl%20sheet%20flooring%20installation%20process%20worker%20unrolling%20and%20smoothing%20grey%20vinyl%20floor%20covering%20medical%20facility%20interior%20professional%20tools%20clean%20bright%20environment%20construction%20site%20East%20Asian%20worker&width=800&height=600&seq=floor-002-g2&orientation=landscape',
        caption: '施工中の様子',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=medical%20examination%20room%20with%20clean%20vinyl%20sheet%20flooring%20installed%20bright%20clinical%20interior%20professional%20finish%20antiseptic%20floor%20material%20high%20quality%20healthcare%20renovation%20result%20East%20Asian%20worker&width=800&height=600&seq=floor-002-g3&orientation=landscape',
        caption: '診察室 — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=vinyl%20floor%20sheet%20welding%20joint%20detail%20close%20up%20professional%20finish%20seamless%20weld%20treatment%20long%20sheet%20flooring%20installation%20high%20quality%20craftsmanship%20medical%20facility%20renovation%20clean%20precise%20edge%20East%20Asian%20worker&width=800&height=600&seq=floor-002-g4&orientation=landscape',
        caption: '溶接処理の仕上がり',
      },
    ],
    relatedService: '床仕上工事',
    relatedServiceSlug: 'floor',
  },
  {
    id: 'floor-003',
    title: '床仕上工事 — オフィスタイルカーペット',
    category: '床仕上工事',
    location: '東京都新宿区',
    year: '2023',
    client: '都内IT企業',
    area: '約680㎡',
    duration: '4日間',
    image: 'https://readdy.ai/api/search-image?query=modern%20IT%20company%20open%20plan%20office%20interior%20with%20newly%20installed%20dark%20charcoal%20grey%20tile%20carpet%20flooring%20throughout%20entire%20floor%20contemporary%20workspace%20design%20Shinjuku%20Tokyo%20Japan%20no%20people%20empty%20office%20floor%20clean%20professional%20atmosphere&width=800&height=600&seq=floor-scene-003&orientation=landscape',
    description: '東京都新宿区のオフィスビル（全フロア）におけるタイルカーペット張り替え工事です。既存カーペットの撤去・下地清掃から新規タイルカーペット施工まで一貫して対応しました。デザイン性と機能性を兼ね備えたタイルカーペットを採用し、快適なオフィス環境を実現しました。',
    highlights: [
      '680㎡の大面積施工を4日間で完工',
      '既存カーペット撤去・下地清掃を徹底',
      'デザイン性・吸音性・帯電防止機能付きタイルカーペット採用',
      '夜間・週末施工によるオフィス稼働への影響最小化',
      '部分交換が容易なタイルカーペット工法を採用',
    ],
    galleryImages: [
      {
        src: 'https://readdy.ai/api/search-image?query=modern%20office%20interior%20with%20new%20tile%20carpet%20flooring%20installed%20bright%20contemporary%20commercial%20workspace%20clean%20beautiful%20floor%20finish%20professional%20renovation%20result%20open%20plan%20office%20design%20East%20Asian%20worker&width=800&height=600&seq=floor-003-g1&orientation=landscape',
        caption: 'オフィスフロア — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=tile%20carpet%20installation%20process%20worker%20placing%20and%20pressing%20square%20carpet%20tiles%20office%20interior%20professional%20technique%20close%20up%20detail%20clean%20workspace%20modular%20carpet%20floor%20covering%20East%20Asian%20worker&width=800&height=600&seq=floor-003-g2&orientation=landscape',
        caption: '施工中の様子',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=office%20meeting%20room%20with%20tile%20carpet%20flooring%20modern%20interior%20design%20clean%20professional%20workspace%20after%20renovation%20high%20quality%20floor%20finish%20contemporary%20commercial%20interior%20East%20Asian%20worker&width=800&height=600&seq=floor-003-g3&orientation=landscape',
        caption: '会議室 — 施工後',
      },
      {
        src: 'https://readdy.ai/api/search-image?query=tile%20carpet%20floor%20detail%20close%20up%20professional%20finish%20seamless%20joint%20treatment%20modular%20carpet%20installation%20high%20quality%20craftsmanship%20office%20renovation%20clean%20precise%20edge%20work%20pattern%20alignment%20East%20Asian%20worker&width=800&height=600&seq=floor-003-g4&orientation=landscape',
        caption: 'タイルカーペット仕上がり詳細',
      },
    ],
    relatedService: '床仕上工事',
    relatedServiceSlug: 'floor',
  },
];
